import { extractCookie } from './links';

export default function getLocale(vuexStore, cookies) {
  const lang = vuexStore.getters['translation/getLanguage'];
  return lang || extractCookie(cookies, 'langCode', 'en');
}
